import types from './types';

export { default as auth } from './auth';

export const clean = () => {
  return {
    type: types.CLEAN
  };
};

// STEPS
export const setStepsList = steps => {
  return {
    type: types.SET_STEPS_LIST,
    payload: steps
  };
};

export const increaseStepByOne = () => {
  return {
    type: types.INCREASE_STEP
  };
};

export const decreaseStepByOne = () => {
  return {
    type: types.DECREASE_STEP
  };
};

export const setInnerPagesList = pages => {
  return {
    type: types.SET_INNER_PAGES_LIST,
    payload: pages
  };
};

export const setStepInnerPage = page => {
  return {
    type: types.SET_STEP_INNER_PAGE,
    payload: page
  };
};

export const showError = show => {
  return {
    type: types.SHOW_ERROR,
    payload: show
  };
};

export const showLoading = show => {
  return {
    type: types.SHOW_LOADING,
    payload: show
  };
};

export const showInnerLoading = show => {
  return {
    type: types.SHOW_INNER_LOADING,
    payload: show
  };
};

// OPTIONS
export const setOptionsValue = (type, value) => {
  return {
    type: types.SET_OPTIONS_VALUE,
    payload: { type, value }
  };
};

export const setOptionsList = (type, list) => {
  return {
    type: types.SET_OPTIONS_LIST,
    payload: { type, list }
  };
};

// CLIENT
export const setClientValue = (type, value) => {
  return {
    type: types.SET_CLIENT_VALUE,
    payload: { type, value }
  };
};

// HOME
export const setHomeValue = (type, value) => {
  return {
    type: types.SET_HOME_VALUE,
    payload: { type, value }
  };
};

// APERSONAL
export const setAPersonalValue = (type, value) => {
  return {
    type: types.SET_APERSONAL_VALUE,
    payload: { type, value }
  };
};


// PYME
export const setPymeValue = (type, value) => {
  return {
    type: types.SET_PYME_VALUE,
    payload: { type, value }
  };
};

export const setPymeList = (type, list) => {
  return {
    type: types.SET_PYME_LIST,
    payload: { type, list }
  };
};

// VEHICLES
export const setVehiclesValue = (type, value) => {
  return {
    type: types.SET_VEHICLES_VALUE,
    payload: { type, value }
  };
};

export const goBackAuto = cleanValue => {
  return {
    type: types.GO_BACK_AUTO,
    payload: { cleanValue }
  };
};

// YATES
export const setYatesValue = (type, value) => {
  return {
    type: types.SET_YATES_VALUE,
    payload: { type, value }
  };
};

// QUOTATION
export const setOptionalQuotationValue = value => {
  return {
    type: types.SET_OPTIONAL_QUOTATION_VALUE,
    payload: { value }
  };
};

export const setQuotation = (
  type,
  quote,
  options = {
    coverageModule: 1,
    isFinal: true,
    withOptional: false,
    economic: false
  }
) => {
  return {
    type: types.SET_QUOTATION,
    payload: { type, quote, options }
  };
};

export const cleanQuotation = () => {
  return {
    type: types.CLEAN_QUOTATION
  };
};

export const cleanQuotationError = () => {
  return {
    type: types.CLEAN_QUOTATION_ERROR
  };
};

// PAYMENT
export const setInstallments = installments => {
  return {
    type: types.SET_INSTALLMENTS,
    payload: installments
  };
};

export const cleanInstallments = () => {
  return {
    type: types.CLEAN_INSTALLMENTS
  };
};

export const setPaymentValue = (type, value) => {
  return {
    type: types.SET_PAYMENT_VALUE,
    payload: { type, value }
  };
};

export const toggleTermsCheck = () => {
  return {
    type: types.TOGGLE_TERMS_CHECK
  };
};

// GTIA ALQUIILER
export const setRentalValue = (type, value) => {
  return {
    type: types.SET_RENTAL_VALUE,
    payload: { type, value }
  };
};

// SALUD
export const setHealthValue = (type, value) => {
  return {
    type: types.SET_HEALTH_VALUE,
    payload: { type, value }
  };
};

export const setPersonBirthdate = value => {
  return {
    type: types.SET_PERSON_BIRTHDATE,
    payload: value
  };
};

export const setQuotationSalud = quotation => {
  return {
    type: types.SET_QUOTATION_SALUD,
    payload: quotation
  };
};
